import { useCallback, useEffect, useState } from 'react';

import { FN_EQUALS_DEEP } from 'state_management/recoilStates/helpers-v2';

import { getOS, OSType } from './utils';

export enum EventCode {
  BACKSPACE = 'Backspace',
  TAB = 'Tab',
  ENTER = 'Enter',
  NUMPAD_ENTER = 'NumpadEnter',
  SHIFT_LEFT = 'ShiftLeft',
  SHIFT_RIGHT = 'ShiftRight',
  CONTROL_LEFT = 'ControlLeft',
  CONTROL_RIGHT = 'ControlRight',
  ALT_LEFT = 'AltLeft',
  ALT_RIGHT = 'AltRight',
  CAPS_LOCK = 'CapsLock',
  ESCAPE = 'Escape',
  SPACE = 'Space',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_UP = 'ArrowUp',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_DOWN = 'ArrowDown',
  DELETE = 'Delete',
  DIGIT_0 = 'Digit0',
  DIGIT_1 = 'Digit1',
  DIGIT_2 = 'Digit2',
  DIGIT_3 = 'Digit3',
  DIGIT_4 = 'Digit4',
  DIGIT_5 = 'Digit5',
  DIGIT_6 = 'Digit6',
  DIGIT_7 = 'Digit7',
  DIGIT_8 = 'Digit8',
  DIGIT_9 = 'Digit9',
  KEY_A = 'KeyA',
  KEY_B = 'KeyB',
  KEY_C = 'KeyC',
  KEY_D = 'KeyD',
  KEY_E = 'KeyE',
  KEY_F = 'KeyF',
  KEY_G = 'KeyG',
  KEY_H = 'KeyH',
  KEY_I = 'KeyI',
  KEY_J = 'KeyJ',
  KEY_K = 'KeyK',
  KEY_L = 'KeyL',
  KEY_M = 'KeyM',
  KEY_N = 'KeyN',
  KEY_O = 'KeyO',
  KEY_P = 'KeyP',
  KEY_Q = 'KeyQ',
  KEY_R = 'KeyR',
  KEY_S = 'KeyS',
  KEY_T = 'KeyT',
  KEY_U = 'KeyU',
  KEY_V = 'KeyV',
  KEY_W = 'KeyW',
  KEY_X = 'KeyX',
  KEY_Y = 'KeyY',
  KEY_Z = 'KeyZ',
  META_LEFT = 'MetaLeft',
  META_RIGHT = 'MetaRight',
  F1 = 'F1',
  F2 = 'F2',
  F3 = 'F3',
  F4 = 'F4',
  F5 = 'F5',
  F6 = 'F6',
  F7 = 'F7',
  F8 = 'F8',
  F9 = 'F9',
  F10 = 'F10',
  F11 = 'F11',
  F12 = 'F12',
  SEMICOLON = 'Semicolon',
  EQUAL = 'Equal',
  COMMA = 'Comma',
  MINUS = 'Minus',
  PERIOD = 'Period',
  SLASH = 'Slash',
  BACKQUOTE = 'Backquote',
  BRACKET_LEFT = 'BracketLeft',
  BACKSLASH = 'Backslash',
  BRACKET_RIGHT = 'BracketRight',
  QUOTE = 'Quote'
}
export enum EventKey {
  BACKSPACE = 'Backspace',
  TAB = 'Tab',
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  SHIFT = 'Shift',
  CONTROL = 'Control',
  ALT = 'Alt',
  CAPSLOCK = 'CapsLock',
  SPACE = ' ',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_UP = 'ArrowUp',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_DOWN = 'ArrowDown',
  DELETE = 'Delete',
  META = 'Meta',
  F1 = 'F1',
  F2 = 'F2',
  F3 = 'F3',
  F4 = 'F4',
  F5 = 'F5',
  F6 = 'F6',
  F7 = 'F7',
  F8 = 'F8',
  F9 = 'F9',
  F10 = 'F10',
  F11 = 'F11',
  F12 = 'F12',
  BACKSLASH = '\\',
  BACKTICK = '`',
  BRACE_CLOSE = '}',
  BRACE_OPEN = '{',
  BRACKET_CLOSE = ']',
  BRACKET_OPEN = '[',
  CHAR_A_LOWER = 'a',
  CHAR_A_UPPER = 'A',
  CHAR_AMPERSAND = '&',
  CHAR_AT = '@',
  CHAR_B_LOWER = 'b',
  CHAR_B_UPPER = 'B',
  CHAR_C_LOWER = 'c',
  CHAR_C_UPPER = 'C',
  CHAR_CARET = '^',
  CHAR_D_LOWER = 'd',
  CHAR_D_UPPER = 'D',
  CHAR_DOLLAR = '$',
  CHAR_E_LOWER = 'e',
  CHAR_E_UPPER = 'E',
  CHAR_EXCLAMATION = '!',
  CHAR_F_LOWER = 'f',
  CHAR_F_UPPER = 'F',
  CHAR_G_LOWER = 'g',
  CHAR_G_UPPER = 'G',
  CHAR_H_LOWER = 'h',
  CHAR_H_UPPER = 'H',
  CHAR_HASH = '#',
  CHAR_I_LOWER = 'i',
  CHAR_I_UPPER = 'I',
  CHAR_J_LOWER = 'j',
  CHAR_J_UPPER = 'J',
  CHAR_K_LOWER = 'k',
  CHAR_K_UPPER = 'K',
  CHAR_L_LOWER = 'l',
  CHAR_L_UPPER = 'L',
  CHAR_M_LOWER = 'm',
  CHAR_M_UPPER = 'M',
  CHAR_N_LOWER = 'n',
  CHAR_N_UPPER = 'N',
  CHAR_O_LOWER = 'o',
  CHAR_O_UPPER = 'O',
  CHAR_P_LOWER = 'p',
  CHAR_P_UPPER = 'P',
  CHAR_PARENTHESIS_CLOSE = ')',
  CHAR_PARENTHESIS_OPEN = '(',
  CHAR_PERCENT = '%',
  CHAR_Q_LOWER = 'q',
  CHAR_Q_UPPER = 'Q',
  CHAR_R_LOWER = 'r',
  CHAR_R_UPPER = 'R',
  CHAR_S_LOWER = 's',
  CHAR_S_UPPER = 'S',
  CHAR_STAR = '*',
  CHAR_T_LOWER = 't',
  CHAR_T_UPPER = 'T',
  CHAR_U_LOWER = 'u',
  CHAR_U_UPPER = 'U',
  CHAR_V_LOWER = 'v',
  CHAR_V_UPPER = 'V',
  CHAR_W_LOWER = 'w',
  CHAR_W_UPPER = 'W',
  CHAR_X_LOWER = 'x',
  CHAR_X_UPPER = 'X',
  CHAR_Y_LOWER = 'y',
  CHAR_Y_UPPER = 'Y',
  CHAR_Z_LOWER = 'z',
  CHAR_Z_UPPER = 'Z',
  COLON = ':',
  COMMA = ',',
  DASH = '-',
  DEAD = 'Dead',
  DIGIT_0 = '0',
  DIGIT_1 = '1',
  DIGIT_2 = '2',
  DIGIT_3 = '3',
  DIGIT_4 = '4',
  DIGIT_5 = '5',
  DIGIT_6 = '6',
  DIGIT_7 = '7',
  DIGIT_8 = '8',
  DIGIT_9 = '9',
  DOUBLE_QUOTE = '"',
  EQUALS = '=',
  GT = '>',
  LT = '<',
  PERIOD = '.',
  PIPE = '|',
  PLUS = '+',
  QUESTION = '?',
  SEMICOLON = ';',
  SINGLE_QUOTE = "'",
  SLASH = '/',
  TILDE = '~',
  UNDERSCORE = '_'
}

export type KeyboardShortcut = {
  os?: OSType;
  commandOrWinKey?: boolean;
  optionOrAltKey?: boolean;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  repeat?: boolean;
  keys?: EventKey[];
  codes?: EventCode[];
};

export function useKeyboardShortcut(shortcuts: KeyboardShortcut[], id: string) {
  const [savedShortcuts, setSavedShortcuts] = useState(shortcuts);
  useEffect(() => {
    setSavedShortcuts((value) => (FN_EQUALS_DEEP(value, shortcuts) ? value : shortcuts));
  }, [shortcuts]);
  return useCallback(
    (ev: React.KeyboardEvent | KeyboardEvent) => {
      return savedShortcuts.some(({ os, commandOrWinKey, optionOrAltKey, ctrlKey, shiftKey, keys, codes, repeat }) => {
        // If OS was mentioned and is different from current OS, ignore
        if (os !== undefined && getOS() !== os) return false;
        // If REPEAT flag was mentioned and is different from current REPEAT flag, ignore
        if (repeat !== undefined && ev.repeat !== repeat) return false;
        // If META key state was mentioned and is different from current META ket state, ignore
        // MacOS   -> META = COMMAND
        // Windows -> META = WIN
        if (commandOrWinKey !== undefined && ev.metaKey !== commandOrWinKey) return false;
        // If ALT key state was mentioned and is different from current ALT ket state, ignore
        // MacOS   -> ALT = OPTION
        // Windows -> ALT = ALT
        if (optionOrAltKey !== undefined && ev.altKey !== optionOrAltKey) return false;
        // If CTRL key state was mentioned and is different from current CTRL ket state, ignore
        if (ctrlKey !== undefined && ev.ctrlKey !== ctrlKey) return false;
        // If SHIFT key state was mentioned and is different from current SHIFT ket state, ignore
        if (shiftKey !== undefined && ev.shiftKey !== shiftKey) return false;
        // If keys were mentioned and match event key, trigger
        if (keys && !keys?.includes(ev.key as EventKey)) return false;
        // If codes were mentioned and match event keyCode, trigger
        if (codes && !codes?.includes(ev.code as EventCode)) return false;

        return true;
      });
    },
    [savedShortcuts]
  );
}

/**
 * ```
 * MacOS   = Command+C (no other modifier keys pressed, not repeating)
 * Windows = Ctrl+C    (no other modifier keys pressed, not repeating)
 * ```
 */
export function useCopyShortcut(id: string) {
  return useKeyboardShortcut(
    [
      { os: OSType.MACOS, commandOrWinKey: true, optionOrAltKey: false, ctrlKey: false, shiftKey: false, codes: [EventCode.KEY_C], repeat: false },
      { os: OSType.WINDOWS, commandOrWinKey: false, optionOrAltKey: false, ctrlKey: true, shiftKey: false, codes: [EventCode.KEY_C], repeat: false }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Command+X (no other modifier keys pressed, not repeating)
 * Windows = Ctrl+X    (no other modifier keys pressed, not repeating)
 * ```
 */
export function useCutShortcut(id: string) {
  return useKeyboardShortcut(
    [
      { os: OSType.MACOS, commandOrWinKey: true, optionOrAltKey: false, ctrlKey: false, shiftKey: false, codes: [EventCode.KEY_X], repeat: false },
      { os: OSType.WINDOWS, commandOrWinKey: false, optionOrAltKey: false, ctrlKey: true, shiftKey: false, codes: [EventCode.KEY_X], repeat: false }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Command+V (no other modifier keys pressed, not repeating)
 * Windows = Ctrl+V    (no other modifier keys pressed, not repeating)
 * ```
 */
export function usePasteShortcut(id: string) {
  return useKeyboardShortcut(
    [
      { os: OSType.MACOS, commandOrWinKey: true, optionOrAltKey: false, ctrlKey: false, shiftKey: false, codes: [EventCode.KEY_V], repeat: false },
      { os: OSType.WINDOWS, commandOrWinKey: false, optionOrAltKey: false, ctrlKey: true, shiftKey: false, codes: [EventCode.KEY_V], repeat: false }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Command+Z (no other modifier keys pressed, not repeating)
 * Windows = Ctrl+Z    (no other modifier keys pressed, not repeating)
 * ```
 */
export function useUndoShortcut(id: string) {
  return useKeyboardShortcut(
    [
      { os: OSType.MACOS, commandOrWinKey: true, optionOrAltKey: false, ctrlKey: false, shiftKey: false, codes: [EventCode.KEY_Z], repeat: false },
      { os: OSType.WINDOWS, commandOrWinKey: false, optionOrAltKey: false, ctrlKey: true, shiftKey: false, codes: [EventCode.KEY_Z], repeat: false }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Command+Shift+Z (no other modifier keys pressed, not repeating)
 * Windows = Ctrl+Shift+Z    (no other modifier keys pressed, not repeating)
 * ```
 */
export function useRedoShortcut(id: string) {
  return useKeyboardShortcut(
    [
      { os: OSType.MACOS, commandOrWinKey: true, optionOrAltKey: false, ctrlKey: false, shiftKey: true, codes: [EventCode.KEY_Z], repeat: false },
      { os: OSType.WINDOWS, commandOrWinKey: false, optionOrAltKey: false, ctrlKey: true, shiftKey: true, codes: [EventCode.KEY_Z], repeat: false }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Command+A (no other modifier keys pressed, not repeating)
 * Windows = Ctrl+A    (no other modifier keys pressed, not repeating)
 * ```
 */
export function useSelectAllShortcut(id: string) {
  return useKeyboardShortcut(
    [
      { os: OSType.MACOS, commandOrWinKey: true, optionOrAltKey: false, ctrlKey: false, shiftKey: false, codes: [EventCode.KEY_A], repeat: false },
      { os: OSType.WINDOWS, commandOrWinKey: false, optionOrAltKey: false, ctrlKey: true, shiftKey: false, codes: [EventCode.KEY_A], repeat: false }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Command+A (no other modifier keys pressed)
 * Windows = Ctrl+A    (no other modifier keys pressed)
 * ```
 */
export function useGlobalSelectAllShortcut(id: string) {
  return useKeyboardShortcut(
    [
      { os: OSType.MACOS, commandOrWinKey: true, optionOrAltKey: false, ctrlKey: false, shiftKey: false, codes: [EventCode.KEY_A] },
      { os: OSType.WINDOWS, commandOrWinKey: false, optionOrAltKey: false, ctrlKey: true, shiftKey: false, codes: [EventCode.KEY_A] }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Backspace/Delete (not repeating)
 * Windows = Backspace/Delete (not repeating)
 * ```
 */
export function useDeleteShortcut(id: string) {
  // FIXME: Can we add [Meta=false, Ctrl=false, Alt=false, Shift=false]?
  return useKeyboardShortcut([{ codes: [EventCode.BACKSPACE, EventCode.DELETE], repeat: false }], id);
}

/**
 * ```
 * MacOS   = Shift+Enter (no other modifier keys pressed, not repeating)
 * Windows = Shift+Enter (no other modifier keys pressed, not repeating)
 * ```
 */
export function useShiftEnterShortcut(id: string) {
  return useKeyboardShortcut([{ commandOrWinKey: false, ctrlKey: false, optionOrAltKey: false, shiftKey: true, codes: [EventCode.ENTER, EventCode.NUMPAD_ENTER], repeat: false }], id);
}
/**
 * ```
 * MacOS   = Command+Enter (no other modifier keys pressed, not repeating)
 * Windows = Ctrl+Enter    (no other modifier keys pressed, not repeating)
 * ```
 */
export function useCtrlEnterShortcut(id: string) {
  return useKeyboardShortcut(
    [
      { os: OSType.MACOS, commandOrWinKey: true, optionOrAltKey: false, ctrlKey: false, shiftKey: false, codes: [EventCode.ENTER, EventCode.NUMPAD_ENTER], repeat: false },
      { os: OSType.WINDOWS, commandOrWinKey: false, ctrlKey: true, optionOrAltKey: false, shiftKey: false, codes: [EventCode.ENTER, EventCode.NUMPAD_ENTER], repeat: false }
    ],
    id
  );
}
/**
 * ```
 * MacOS   = F9 (no other modifier keys pressed, not repeating)
 * Windows = F9 (no other modifier keys pressed, not repeating)
 * ```
 */
export function useSchedulingShortcut(id: string) {
  return useKeyboardShortcut([{ codes: [EventCode.F9], commandOrWinKey: false, optionOrAltKey: false, ctrlKey: false, shiftKey: false, repeat: false }], id);
}

/**
 * ```
 * MacOS   = Command/Tab/ArrowUp/ArrowDown/ArrowLeft/ArrowRight/Command+Tab/Command+ArrowUp/Command+ArrowDown/Command+ArrowLeft/Command+ArrowRight (repeating)
 * Windows = Command/Tab/ArrowUp/ArrowDown/ArrowLeft/ArrowRight/Command+Tab/Command+ArrowUp/Command+ArrowDown/Command+ArrowLeft/Command+ArrowRight (repeating)
 * ```
 */
export function useTableIgnoredShortcuts(id: string) {
  return useKeyboardShortcut(
    [
      // FIXME: Need to recheck if these shortcuts are still needed
      { codes: [EventCode.TAB, EventCode.ARROW_UP, EventCode.ARROW_DOWN, EventCode.ARROW_LEFT, EventCode.ARROW_RIGHT] },
      { os: OSType.MACOS, commandOrWinKey: true },
      { os: OSType.WINDOWS, ctrlKey: true }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Command+Shift/Command+ArrowLeft/Command+ArrowRight (repeating)
 * Windows = Command+Shift/Command+ArrowLeft/Command+ArrowRight (repeating)
 * ```
 */
export function useNotLassoShortcut(id: string) {
  return useKeyboardShortcut(
    [
      // FIXME: Need to recheck if these shortcuts are still needed
      { os: OSType.MACOS, commandOrWinKey: true, shiftKey: true },
      { os: OSType.MACOS, commandOrWinKey: true, codes: [EventCode.ARROW_LEFT, EventCode.ARROW_RIGHT] },
      { os: OSType.WINDOWS, ctrlKey: true, shiftKey: true },
      { os: OSType.WINDOWS, ctrlKey: true, codes: [EventCode.ARROW_LEFT, EventCode.ARROW_RIGHT] }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Command (not repeating)
 * Windows = Ctrl    (not repeating)
 * ```
 */
export function useLassoShortcut(id: string) {
  return useKeyboardShortcut(
    [
      // FIXME: Can we add [Alt=false, Shift=false]?
      { os: OSType.MACOS, commandOrWinKey: true, repeat: false },
      { os: OSType.WINDOWS, ctrlKey: true, repeat: false },
      { os: OSType.MACOS, shiftKey: true, repeat: false },
      { os: OSType.WINDOWS, shiftKey: true, repeat: false }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Command (no other modifier keys pressed, not repeating), Shift
 * Windows = Ctrl    (no other modifier keys pressed, not repeating), shift
 * ```
 */
export function useCancelLassoShortcut(id: string) {
  return useKeyboardShortcut(
    [
      // FIXME: Need to recheck if these shortcuts are still needed
      { os: OSType.MACOS, commandOrWinKey: false, optionOrAltKey: false, ctrlKey: false, shiftKey: false, codes: [EventCode.META_LEFT, EventCode.META_RIGHT] },
      { os: OSType.WINDOWS, commandOrWinKey: false, optionOrAltKey: false, ctrlKey: false, shiftKey: false, codes: [EventCode.CONTROL_LEFT, EventCode.CONTROL_RIGHT] },
      { os: OSType.MACOS, shiftKey: false, repeat: false },
      { os: OSType.WINDOWS, shiftKey: false, repeat: false }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Command+R (no other modifier keys pressed, not repeating)
 * Windows = Ctrl+R    (no other modifier keys pressed, not repeating)
 * ```
 */
export function useBrowserRefresh(id: string) {
  return useKeyboardShortcut(
    [
      { os: OSType.MACOS, commandOrWinKey: true, optionOrAltKey: false, shiftKey: false, ctrlKey: false, codes: [EventCode.KEY_R], repeat: false },
      { os: OSType.WINDOWS, commandOrWinKey: false, optionOrAltKey: false, shiftKey: false, ctrlKey: true, codes: [EventCode.KEY_R], repeat: false }
    ],
    id
  );
}

/**
 * ```
 * MacOS   = Command+Shift+W | Command+W (no other modifier keys pressed, not repeating)
 * Windows = Ctrl+Shift+W | Ctrl+W   (no other modifier keys pressed, not repeating)
 * ```
 */
export function useBrowserClose(id: string) {
  return useKeyboardShortcut(
    [
      { os: OSType.MACOS, commandOrWinKey: true, optionOrAltKey: false, codes: [EventCode.KEY_W], repeat: false },
      { os: OSType.WINDOWS, commandOrWinKey: false, optionOrAltKey: false, ctrlKey: true, codes: [EventCode.KEY_W], repeat: false }
    ],
    id
  );
}

const alphaKeys = [EventCode.KEY_A, EventCode.KEY_B, EventCode.KEY_C, EventCode.KEY_D, EventCode.KEY_E, EventCode.KEY_F, EventCode.KEY_G, EventCode.KEY_H, EventCode.KEY_I, EventCode.KEY_J, EventCode.KEY_K, EventCode.KEY_L, EventCode.KEY_M, EventCode.KEY_N, EventCode.KEY_O, EventCode.KEY_P, EventCode.KEY_Q, EventCode.KEY_R, EventCode.KEY_S, EventCode.KEY_T, EventCode.KEY_U, EventCode.KEY_V, EventCode.KEY_W, EventCode.KEY_X, EventCode.KEY_Y, EventCode.KEY_Z];
const digits = [EventCode.DIGIT_0, EventCode.DIGIT_1, EventCode.DIGIT_2, EventCode.DIGIT_3, EventCode.DIGIT_4, EventCode.DIGIT_5, EventCode.DIGIT_6, EventCode.DIGIT_7, EventCode.DIGIT_8, EventCode.DIGIT_9];
const alphaAndDigits = [...alphaKeys, ...digits];

export const isAlphaOrDigit = (eventCode: EventCode) => {
  return alphaAndDigits.includes(eventCode);
};
